<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOverige">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOverige" aria-expanded="false" aria-controls="collapseOverige">
                Overige schenkingen
            </button>
        </h2>
        <div id="collapseOverige" class="accordion-collapse collapse" aria-labelledby="headingOverige"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Alle vermogensoverdrachten zonder tegenprestatie die niet onder specifieke categorieën vallen (zoals
                licentierechten, vruchtgebruik, beperkte rechten, vorderingen op derden) vallen hieronder. Deze moeten
                gewaardeerd worden naar economische waarde, eventueel op basis van een rekenkundige benadering of een
                extern taxatierapport.
                <div class="space20"></div>
                Let op dat ook passieve vermogensverschuivingen – zoals het afzien van
                dividendrechten of afstand doen van aandeelhoudersrechten – onder omstandigheden als schenking kunnen
                worden aangemerkt.
            </div>
        </div>
    </div>
</div>

